console.log('APP_URL', process.env.APP_URL)
export default {
  locale: process.env.DEFAULT_LOCALE,
  url: process.env.APP_URL,
  persistStoreEnabled: Number(process.env.REACT_APP_PERSIST_STORE_ENABLED) === 1,
  revealDate: process.env.REVEAL_DATE as string,
  isRevealed: process.env.IS_REVEALED === 'true' || String(process.env.IS_REVEALED) === '1',
}
